// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2Apul","selected":"Chip_selected__1Djf8"};